import FileIcon from '@/assets/icons/sidebar-navigation/file.svg?react';
import FingerprintIcon from '@/assets/icons/sidebar-navigation/fingerprint.svg?react';
import MailIcon from '@/assets/icons/sidebar-navigation/mail.svg?react';
import NewspaperIcon from '@/assets/icons/sidebar-navigation/newspaper.svg?react';
import PinIcon from '@/assets/icons/sidebar-navigation/pin.svg?react';

export const navItems = [
  { to: '/route', icon: PinIcon, label: 'Routenplaner' },
  { to: '/info', icon: NewspaperIcon, label: 'Projektinfos' },
  { to: '/imprint', icon: FileIcon, label: 'Impressum' },
  { to: '/legal', icon: FingerprintIcon, label: 'Datenschutz' },
  { to: '/contact', icon: MailIcon, label: 'Kontakt' },
];
